import MksDateNumber from "./DateNumber.vue";
import MksButton from "./Button.vue";
import MksFieldError from "./FieldError.vue";
import MksAvatar from "./Avatar.vue";
import MksFieldLabel from "./FieldLabel.vue";
import MksHeading from "./Heading.vue";
import MksLink from "./Link.vue";
import MksIcon from "./Icon.vue";
import MksAlert from "./Alert.vue";
import MksLoading from "./Loading.vue";
import MksNumber from "./Number.vue";
import MksLogotype from "./Logotype.vue";
import MksSeparator from "./Separator.vue";
import MksTab from "./Tab.vue";
import MksText from "./Text.vue";
import MksToggle from "./Toggle.vue";
import MksVisuallyHidden from "./VisuallyHidden.vue";
import MksTag from "./Tag.vue";

const atoms = {
  MksDateNumber,
  MksButton,
  MksFieldError,
  MksAvatar,
  MksFieldLabel,
  MksHeading,
  MksLink,
  MksIcon,
  MksAlert,
  MksLoading,
  MksNumber,
  MksLogotype,
  MksSeparator,
  MksTab,
  MksText,
  MksToggle,
  MksVisuallyHidden,
  MksTag
};

export default {
  install(vueApp) {
    Object.entries(atoms).forEach(([name, component]) => {
      vueApp.component(name, component);
    });
  }
}
